import { Component, Inject, OnInit } from '@angular/core';
import { AppService } from '../../../../../app.service';
import { ClearFlagVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { DigitalFormService } from '../../digital-form.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AesDecryptPipe } from '../../../../../shared/pipes/aes-decrypt.pipe';

@Component({
  selector: 'app-flag-comment',
  templateUrl: './flag-comment.component.html',
  styleUrls: ['./flag-comment.component.scss'],
  providers: [AesDecryptPipe]
})
export class FlagCommentComponent implements OnInit {

  exsitingcomment:string;
  comment:string;
  commentlist:string[];
  isInstructions:boolean=false;
  header:string;

  constructor(
    private _dialogRef: MatDialogRef<FlagCommentComponent>, 
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _appService: AppService,
    private _formService:DigitalFormService, 
    private _aesDecrypt: AesDecryptPipe) { }

  ngOnInit() {
    this. isInstructions = this._data. isInstructions;
    this.comment=this._data.comment;
    this.header=this._data.header;
    this.exsitingcomment=this._data.exsitingcomment;
    let arr_comments= this.exsitingcomment.split('-newcomment-');
    console.log("arr_comments",arr_comments)
    this.commentlist=arr_comments;
    console.log("this.commentlist",this.commentlist);
    this.decryptUsername();
  }

  onSave(){
    let clearflag = new ClearFlagVM();
    clearflag.Id = 3;
    clearflag.Comment = this.comment;
    this._dialogRef.close(clearflag);
  }

  onNoClick(){
    let clearflag = new ClearFlagVM();
    clearflag.Comment = this.comment;
    clearflag.Id = 0;
    this._dialogRef.close(clearflag);
  }

  decryptUsername() {
    this.commentlist.forEach((comment, i) => {
      const dashIndex = comment.lastIndexOf('-');
      if (dashIndex >= 0) {
        const beforeUser = comment.substring(0, dashIndex + 1).trim();
        const afterDash = comment.substring(dashIndex + 1).trim();
        const encryptedUsername = afterDash.split(' ')[0];
        const rest = afterDash.substring(encryptedUsername.length).trim();
        const decryptedUsername = this._aesDecrypt.transform(encryptedUsername);
        const finalComment = `${beforeUser} ${decryptedUsername} ${rest}`;
        this.commentlist[i] = finalComment;
      }
    });
  }
}
